import * as React from 'react';
import cn from 'classnames';

import { X } from 'src/common/icons';

import styles from './Tag.module.scss';
import messages from './messages';

type TagProps = {
  className?: string;
  text: string;
  onClose?: () => void;
  // Small image before the text, e.g. the asset a "Duplicates of" filter is about.
  imageUrl?: string;
};

export const Tag: React.FC<TagProps> = ({ text, onClose, imageUrl, className, ...rest }) => {
  return (
    <div className={cn([styles.Tag, className, { [styles.closeable]: onClose, [styles.withImage]: imageUrl }])}>
      {imageUrl && <img className={styles.image} src={imageUrl} alt="" />}
      {text}
      {onClose && (
        <span onClick={onClose}>
          <X />
        </span>
      )}
    </div>
  );
};

export default Tag;
